/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationPdfSettingsBox_TemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationPdfSettingsBox_TemplatesQuery = { organisationPdfGeneratorTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationPdfGeneratorTemplatesResult', assignedPdfLetterheadIds: Array<string> } };

export type OrganisationPdfSettingsBox_PdfLetterheadFragment = { __typename: 'PdfLetterhead', id: string, name: string, isDefault: boolean, attachment: { __typename: 'PdfLetterheadAttachment', url: string }, settings: { __typename: 'PdfLetterheadSettings', marginTopFirstPage: string, marginTopSubsequentPage: string, marginBottom: string, marginLeft: string, marginRight: string, primaryColor: string, secondaryColor: string, textPrimaryColor: string, textSecondaryColor: string } };

export type GenerateOrganisationPdfLetterheadModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GenerateOrganisationPdfLetterheadModalQuery = { organisationPdfSettings: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PdfSettings', id: string, pdfFooterColumn1: string, pdfFooterColumn2: string, pdfFooterColumn3: string, pdfFooterVisibility: Types.PdfVisibility, pdfTextPrimaryColor: string, pdfTextSecondaryColor: string, pdfLogo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } };

export type RequestOrganisationPdfLetterheadUploadUrlMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RequestOrganisationPdfLetterheadUploadUrlMutation = { requestOrganisationPdfLetterheadUploadUrl: { __typename: 'RequestOrganisationLetterheadUploadUrlResult', uploadUrl: string, accessUrl: string } };

export type GenerateOrganisationPdfLetterheadMutationVariables = Types.Exact<{
  input: Types.GenerateOrganisationPdfLetterheadInput;
}>;


export type GenerateOrganisationPdfLetterheadMutation = { generateOrganisationPdfLetterhead: { __typename: 'GenerateOrganisationPdfLetterheadResult', url: string } };

export type GenerateExamplePdfDocumentMutationVariables = Types.Exact<{
  input: Types.GenerateExamplePdfDocumentInput;
}>;


export type GenerateExamplePdfDocumentMutation = { generateExamplePdfDocument: { __typename: 'GenerateExamplePdfDocumentResult', url: string } };

export type CreateOrganisationPdfLetterheadMutationVariables = Types.Exact<{
  input: Types.CreateOrganisationPdfLetterheadInput;
}>;


export type CreateOrganisationPdfLetterheadMutation = { createOrganisationPdfLetterhead: { __typename: 'CreateOrganisationPdfLetterheadResult', pdfSettings: { __typename: 'PdfSettings', id: string, pdfLetterheads: Array<{ __typename: 'PdfLetterhead', id: string, name: string, isDefault: boolean, attachment: { __typename: 'PdfLetterheadAttachment', url: string }, settings: { __typename: 'PdfLetterheadSettings', marginTopFirstPage: string, marginTopSubsequentPage: string, marginBottom: string, marginLeft: string, marginRight: string, primaryColor: string, secondaryColor: string, textPrimaryColor: string, textSecondaryColor: string } }> } } };

export type ModifyOrganisationPdfLetterheadMutationVariables = Types.Exact<{
  input: Types.ModifyOrganisationPdfLetterheadInput;
}>;


export type ModifyOrganisationPdfLetterheadMutation = { modifyOrganisationPdfLetterhead: { __typename: 'ModifyOrganisationPdfLetterheadResult', pdfSettings: { __typename: 'PdfSettings', id: string, pdfLetterheads: Array<{ __typename: 'PdfLetterhead', id: string, name: string, isDefault: boolean, attachment: { __typename: 'PdfLetterheadAttachment', url: string }, settings: { __typename: 'PdfLetterheadSettings', marginTopFirstPage: string, marginTopSubsequentPage: string, marginBottom: string, marginLeft: string, marginRight: string, primaryColor: string, secondaryColor: string, textPrimaryColor: string, textSecondaryColor: string } }> } } };

export type DeleteOrganisationPdfLetterheadMutationVariables = Types.Exact<{
  input: Types.DeleteOrganisationPdfLetterheadInput;
}>;


export type DeleteOrganisationPdfLetterheadMutation = { deleteOrganisationPdfLetterhead: { __typename: 'DeleteOrganisationPdfLetterheadResult', ok: boolean } };

export type SetDefaultOrganisationPdfLetterheadMutationVariables = Types.Exact<{
  input: Types.SetDefaultOrganisationPdfLetterheadInput;
}>;


export type SetDefaultOrganisationPdfLetterheadMutation = { setDefaultOrganisationPdfLetterhead: { __typename: 'SetDefaultOrganisationPdfLetterheadResult', newDefaultPdfLetterhead: { __typename: 'PdfLetterhead', id: string, name: string, isDefault: boolean, attachment: { __typename: 'PdfLetterheadAttachment', url: string }, settings: { __typename: 'PdfLetterheadSettings', marginTopFirstPage: string, marginTopSubsequentPage: string, marginBottom: string, marginLeft: string, marginRight: string, primaryColor: string, secondaryColor: string, textPrimaryColor: string, textSecondaryColor: string } }, previousDefaultPdfLetterhead?: { __typename: 'PdfLetterhead', id: string, name: string, isDefault: boolean, attachment: { __typename: 'PdfLetterheadAttachment', url: string }, settings: { __typename: 'PdfLetterheadSettings', marginTopFirstPage: string, marginTopSubsequentPage: string, marginBottom: string, marginLeft: string, marginRight: string, primaryColor: string, secondaryColor: string, textPrimaryColor: string, textSecondaryColor: string } } | null } };

export const OrganisationPdfSettingsBox_PdfLetterheadFragmentDoc = gql`
    fragment OrganisationPdfSettingsBox_PdfLetterhead on PdfLetterhead {
  id
  name
  isDefault
  attachment {
    url
  }
  settings {
    marginTopFirstPage
    marginTopSubsequentPage
    marginBottom
    marginLeft
    marginRight
    primaryColor
    secondaryColor
    textPrimaryColor
    textSecondaryColor
  }
}
    `;
export const OrganisationPdfSettingsBox_TemplatesDocument = gql`
    query OrganisationPdfSettingsBox_Templates {
  organisationPdfGeneratorTemplates {
    ... on OrganisationPdfGeneratorTemplatesResult {
      assignedPdfLetterheadIds
    }
  }
}
    `;

/**
 * __useOrganisationPdfSettingsBox_TemplatesQuery__
 *
 * To run a query within a React component, call `useOrganisationPdfSettingsBox_TemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPdfSettingsBox_TemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationPdfSettingsBox_TemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationPdfSettingsBox_TemplatesQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>(OrganisationPdfSettingsBox_TemplatesDocument, options);
      }
export function useOrganisationPdfSettingsBox_TemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>(OrganisationPdfSettingsBox_TemplatesDocument, options);
        }
export function useOrganisationPdfSettingsBox_TemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>(OrganisationPdfSettingsBox_TemplatesDocument, options);
        }
export type OrganisationPdfSettingsBox_TemplatesQueryHookResult = ReturnType<typeof useOrganisationPdfSettingsBox_TemplatesQuery>;
export type OrganisationPdfSettingsBox_TemplatesLazyQueryHookResult = ReturnType<typeof useOrganisationPdfSettingsBox_TemplatesLazyQuery>;
export type OrganisationPdfSettingsBox_TemplatesSuspenseQueryHookResult = ReturnType<typeof useOrganisationPdfSettingsBox_TemplatesSuspenseQuery>;
export type OrganisationPdfSettingsBox_TemplatesQueryResult = Apollo.QueryResult<OrganisationPdfSettingsBox_TemplatesQuery, OrganisationPdfSettingsBox_TemplatesQueryVariables>;
export const GenerateOrganisationPdfLetterheadModalDocument = gql`
    query GenerateOrganisationPdfLetterheadModal {
  organisationPdfSettings {
    ... on PdfSettings {
      id
      pdfFooterColumn1
      pdfFooterColumn2
      pdfFooterColumn3
      pdfFooterVisibility
      pdfTextPrimaryColor
      pdfTextSecondaryColor
      pdfLogo {
        ...AttachmentSnapshot
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;

/**
 * __useGenerateOrganisationPdfLetterheadModalQuery__
 *
 * To run a query within a React component, call `useGenerateOrganisationPdfLetterheadModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganisationPdfLetterheadModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateOrganisationPdfLetterheadModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateOrganisationPdfLetterheadModalQuery(baseOptions?: Apollo.QueryHookOptions<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>(GenerateOrganisationPdfLetterheadModalDocument, options);
      }
export function useGenerateOrganisationPdfLetterheadModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>(GenerateOrganisationPdfLetterheadModalDocument, options);
        }
export function useGenerateOrganisationPdfLetterheadModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>(GenerateOrganisationPdfLetterheadModalDocument, options);
        }
export type GenerateOrganisationPdfLetterheadModalQueryHookResult = ReturnType<typeof useGenerateOrganisationPdfLetterheadModalQuery>;
export type GenerateOrganisationPdfLetterheadModalLazyQueryHookResult = ReturnType<typeof useGenerateOrganisationPdfLetterheadModalLazyQuery>;
export type GenerateOrganisationPdfLetterheadModalSuspenseQueryHookResult = ReturnType<typeof useGenerateOrganisationPdfLetterheadModalSuspenseQuery>;
export type GenerateOrganisationPdfLetterheadModalQueryResult = Apollo.QueryResult<GenerateOrganisationPdfLetterheadModalQuery, GenerateOrganisationPdfLetterheadModalQueryVariables>;
export const RequestOrganisationPdfLetterheadUploadUrlDocument = gql`
    mutation RequestOrganisationPdfLetterheadUploadUrl {
  requestOrganisationPdfLetterheadUploadUrl {
    uploadUrl
    accessUrl
  }
}
    `;
export type RequestOrganisationPdfLetterheadUploadUrlMutationFn = Apollo.MutationFunction<RequestOrganisationPdfLetterheadUploadUrlMutation, RequestOrganisationPdfLetterheadUploadUrlMutationVariables>;

/**
 * __useRequestOrganisationPdfLetterheadUploadUrlMutation__
 *
 * To run a mutation, you first call `useRequestOrganisationPdfLetterheadUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrganisationPdfLetterheadUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrganisationPdfLetterheadUploadUrlMutation, { data, loading, error }] = useRequestOrganisationPdfLetterheadUploadUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestOrganisationPdfLetterheadUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<RequestOrganisationPdfLetterheadUploadUrlMutation, RequestOrganisationPdfLetterheadUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOrganisationPdfLetterheadUploadUrlMutation, RequestOrganisationPdfLetterheadUploadUrlMutationVariables>(RequestOrganisationPdfLetterheadUploadUrlDocument, options);
      }
export type RequestOrganisationPdfLetterheadUploadUrlMutationHookResult = ReturnType<typeof useRequestOrganisationPdfLetterheadUploadUrlMutation>;
export type RequestOrganisationPdfLetterheadUploadUrlMutationResult = Apollo.MutationResult<RequestOrganisationPdfLetterheadUploadUrlMutation>;
export type RequestOrganisationPdfLetterheadUploadUrlMutationOptions = Apollo.BaseMutationOptions<RequestOrganisationPdfLetterheadUploadUrlMutation, RequestOrganisationPdfLetterheadUploadUrlMutationVariables>;
export const GenerateOrganisationPdfLetterheadDocument = gql`
    mutation GenerateOrganisationPdfLetterhead($input: GenerateOrganisationPdfLetterheadInput!) {
  generateOrganisationPdfLetterhead(input: $input) {
    url
  }
}
    `;
export type GenerateOrganisationPdfLetterheadMutationFn = Apollo.MutationFunction<GenerateOrganisationPdfLetterheadMutation, GenerateOrganisationPdfLetterheadMutationVariables>;

/**
 * __useGenerateOrganisationPdfLetterheadMutation__
 *
 * To run a mutation, you first call `useGenerateOrganisationPdfLetterheadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganisationPdfLetterheadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganisationPdfLetterheadMutation, { data, loading, error }] = useGenerateOrganisationPdfLetterheadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOrganisationPdfLetterheadMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrganisationPdfLetterheadMutation, GenerateOrganisationPdfLetterheadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrganisationPdfLetterheadMutation, GenerateOrganisationPdfLetterheadMutationVariables>(GenerateOrganisationPdfLetterheadDocument, options);
      }
export type GenerateOrganisationPdfLetterheadMutationHookResult = ReturnType<typeof useGenerateOrganisationPdfLetterheadMutation>;
export type GenerateOrganisationPdfLetterheadMutationResult = Apollo.MutationResult<GenerateOrganisationPdfLetterheadMutation>;
export type GenerateOrganisationPdfLetterheadMutationOptions = Apollo.BaseMutationOptions<GenerateOrganisationPdfLetterheadMutation, GenerateOrganisationPdfLetterheadMutationVariables>;
export const GenerateExamplePdfDocumentDocument = gql`
    mutation GenerateExamplePdfDocument($input: GenerateExamplePdfDocumentInput!) {
  generateExamplePdfDocument(input: $input) {
    url
  }
}
    `;
export type GenerateExamplePdfDocumentMutationFn = Apollo.MutationFunction<GenerateExamplePdfDocumentMutation, GenerateExamplePdfDocumentMutationVariables>;

/**
 * __useGenerateExamplePdfDocumentMutation__
 *
 * To run a mutation, you first call `useGenerateExamplePdfDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateExamplePdfDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateExamplePdfDocumentMutation, { data, loading, error }] = useGenerateExamplePdfDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateExamplePdfDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateExamplePdfDocumentMutation, GenerateExamplePdfDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateExamplePdfDocumentMutation, GenerateExamplePdfDocumentMutationVariables>(GenerateExamplePdfDocumentDocument, options);
      }
export type GenerateExamplePdfDocumentMutationHookResult = ReturnType<typeof useGenerateExamplePdfDocumentMutation>;
export type GenerateExamplePdfDocumentMutationResult = Apollo.MutationResult<GenerateExamplePdfDocumentMutation>;
export type GenerateExamplePdfDocumentMutationOptions = Apollo.BaseMutationOptions<GenerateExamplePdfDocumentMutation, GenerateExamplePdfDocumentMutationVariables>;
export const CreateOrganisationPdfLetterheadDocument = gql`
    mutation CreateOrganisationPdfLetterhead($input: CreateOrganisationPdfLetterheadInput!) {
  createOrganisationPdfLetterhead(input: $input) {
    pdfSettings {
      id
      pdfLetterheads {
        ...OrganisationPdfSettingsBox_PdfLetterhead
      }
    }
  }
}
    ${OrganisationPdfSettingsBox_PdfLetterheadFragmentDoc}`;
export type CreateOrganisationPdfLetterheadMutationFn = Apollo.MutationFunction<CreateOrganisationPdfLetterheadMutation, CreateOrganisationPdfLetterheadMutationVariables>;

/**
 * __useCreateOrganisationPdfLetterheadMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationPdfLetterheadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationPdfLetterheadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationPdfLetterheadMutation, { data, loading, error }] = useCreateOrganisationPdfLetterheadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationPdfLetterheadMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationPdfLetterheadMutation, CreateOrganisationPdfLetterheadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationPdfLetterheadMutation, CreateOrganisationPdfLetterheadMutationVariables>(CreateOrganisationPdfLetterheadDocument, options);
      }
export type CreateOrganisationPdfLetterheadMutationHookResult = ReturnType<typeof useCreateOrganisationPdfLetterheadMutation>;
export type CreateOrganisationPdfLetterheadMutationResult = Apollo.MutationResult<CreateOrganisationPdfLetterheadMutation>;
export type CreateOrganisationPdfLetterheadMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationPdfLetterheadMutation, CreateOrganisationPdfLetterheadMutationVariables>;
export const ModifyOrganisationPdfLetterheadDocument = gql`
    mutation ModifyOrganisationPdfLetterhead($input: ModifyOrganisationPdfLetterheadInput!) {
  modifyOrganisationPdfLetterhead(input: $input) {
    pdfSettings {
      id
      pdfLetterheads {
        ...OrganisationPdfSettingsBox_PdfLetterhead
      }
    }
  }
}
    ${OrganisationPdfSettingsBox_PdfLetterheadFragmentDoc}`;
export type ModifyOrganisationPdfLetterheadMutationFn = Apollo.MutationFunction<ModifyOrganisationPdfLetterheadMutation, ModifyOrganisationPdfLetterheadMutationVariables>;

/**
 * __useModifyOrganisationPdfLetterheadMutation__
 *
 * To run a mutation, you first call `useModifyOrganisationPdfLetterheadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganisationPdfLetterheadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganisationPdfLetterheadMutation, { data, loading, error }] = useModifyOrganisationPdfLetterheadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyOrganisationPdfLetterheadMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrganisationPdfLetterheadMutation, ModifyOrganisationPdfLetterheadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrganisationPdfLetterheadMutation, ModifyOrganisationPdfLetterheadMutationVariables>(ModifyOrganisationPdfLetterheadDocument, options);
      }
export type ModifyOrganisationPdfLetterheadMutationHookResult = ReturnType<typeof useModifyOrganisationPdfLetterheadMutation>;
export type ModifyOrganisationPdfLetterheadMutationResult = Apollo.MutationResult<ModifyOrganisationPdfLetterheadMutation>;
export type ModifyOrganisationPdfLetterheadMutationOptions = Apollo.BaseMutationOptions<ModifyOrganisationPdfLetterheadMutation, ModifyOrganisationPdfLetterheadMutationVariables>;
export const DeleteOrganisationPdfLetterheadDocument = gql`
    mutation DeleteOrganisationPdfLetterhead($input: DeleteOrganisationPdfLetterheadInput!) {
  deleteOrganisationPdfLetterhead(input: $input) {
    ok
  }
}
    `;
export type DeleteOrganisationPdfLetterheadMutationFn = Apollo.MutationFunction<DeleteOrganisationPdfLetterheadMutation, DeleteOrganisationPdfLetterheadMutationVariables>;

/**
 * __useDeleteOrganisationPdfLetterheadMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationPdfLetterheadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationPdfLetterheadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationPdfLetterheadMutation, { data, loading, error }] = useDeleteOrganisationPdfLetterheadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationPdfLetterheadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationPdfLetterheadMutation, DeleteOrganisationPdfLetterheadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationPdfLetterheadMutation, DeleteOrganisationPdfLetterheadMutationVariables>(DeleteOrganisationPdfLetterheadDocument, options);
      }
export type DeleteOrganisationPdfLetterheadMutationHookResult = ReturnType<typeof useDeleteOrganisationPdfLetterheadMutation>;
export type DeleteOrganisationPdfLetterheadMutationResult = Apollo.MutationResult<DeleteOrganisationPdfLetterheadMutation>;
export type DeleteOrganisationPdfLetterheadMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationPdfLetterheadMutation, DeleteOrganisationPdfLetterheadMutationVariables>;
export const SetDefaultOrganisationPdfLetterheadDocument = gql`
    mutation SetDefaultOrganisationPdfLetterhead($input: SetDefaultOrganisationPdfLetterheadInput!) {
  setDefaultOrganisationPdfLetterhead(input: $input) {
    newDefaultPdfLetterhead {
      ...OrganisationPdfSettingsBox_PdfLetterhead
    }
    previousDefaultPdfLetterhead {
      ...OrganisationPdfSettingsBox_PdfLetterhead
    }
  }
}
    ${OrganisationPdfSettingsBox_PdfLetterheadFragmentDoc}`;
export type SetDefaultOrganisationPdfLetterheadMutationFn = Apollo.MutationFunction<SetDefaultOrganisationPdfLetterheadMutation, SetDefaultOrganisationPdfLetterheadMutationVariables>;

/**
 * __useSetDefaultOrganisationPdfLetterheadMutation__
 *
 * To run a mutation, you first call `useSetDefaultOrganisationPdfLetterheadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultOrganisationPdfLetterheadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultOrganisationPdfLetterheadMutation, { data, loading, error }] = useSetDefaultOrganisationPdfLetterheadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultOrganisationPdfLetterheadMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultOrganisationPdfLetterheadMutation, SetDefaultOrganisationPdfLetterheadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultOrganisationPdfLetterheadMutation, SetDefaultOrganisationPdfLetterheadMutationVariables>(SetDefaultOrganisationPdfLetterheadDocument, options);
      }
export type SetDefaultOrganisationPdfLetterheadMutationHookResult = ReturnType<typeof useSetDefaultOrganisationPdfLetterheadMutation>;
export type SetDefaultOrganisationPdfLetterheadMutationResult = Apollo.MutationResult<SetDefaultOrganisationPdfLetterheadMutation>;
export type SetDefaultOrganisationPdfLetterheadMutationOptions = Apollo.BaseMutationOptions<SetDefaultOrganisationPdfLetterheadMutation, SetDefaultOrganisationPdfLetterheadMutationVariables>;